import LoadingState from "./LoadingState";
import EmptyState from "./EmptyState";
import ArrowUpRight from "../../../assets/svg/ArrowUpRight";
import { NavigationMatch } from "./navigationMatcher";

interface NavigationSectionProps {
  title?: string;
  results: NavigationMatch[];
  isLoading: boolean;
  displayQuery: string;
  searchQuery: string;
  onNavigate: (route: string) => void;
  highlightMatchingText: (text: string, query: string) => JSX.Element;
}

function NavigationSection({
  title = "Navigation",
  results,
  isLoading,
  displayQuery,
  searchQuery,
  onNavigate,
  highlightMatchingText,
}: Readonly<NavigationSectionProps>): JSX.Element {
  let sectionContent: JSX.Element = <LoadingState />;

  if (!isLoading) {
    sectionContent =
      results.length === 0 ? (
        <EmptyState displayQuery={displayQuery} />
      ) : (
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-4">
          <span className="text-sm font-normal text-[#475467]">
            {title}:
          </span>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            {results.map((result) => (
              <button
                key={result.id}
                type="button"
                className="inline-flex items-center gap-1 text-sm font-normal text-primary underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-sideNavGray"
                onClick={() => onNavigate(result.route)}
              >
                <span>{highlightMatchingText(result.title, searchQuery)}</span>
                <ArrowUpRight />
              </button>
            ))}
          </div>
        </div>
      );
  }

  return (
    <div className="border-dropDownBorder bg-white">
      <div className="border-b border-[#F2F2F2] px-5 py-4">
        <p className="text-lg font-semibold leading-[27px] text-[#101828]">
          Results:
        </p>
      </div>
      <div className="border-b border-[#D0D5DD] bg-[#F6F6F6] px-5 py-3">
        {sectionContent}
      </div>
    </div>
  );
}

export default NavigationSection;

